let intersectionObserver;

function ensureIntersectionObserver() {
    if (!window.IntersectionObserver || intersectionObserver) {
        return;
    }

    intersectionObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const eventName = entry.isIntersecting ? 'viewportEnter' : 'viewportExit';
                entry.target.dispatchEvent(new CustomEvent(eventName));
            });
        }
    );
}

/**
 * Track viewport enter and exit
 *
 * Usage:
 * use:viewport
 * onviewportEnter={() => ...}
 * onviewportExit={() => ...}
 */
export const viewport = (element/*, options = {}*/) => {
    if (!window.IntersectionObserver) {
        return;
    }

    ensureIntersectionObserver();

    intersectionObserver.observe(element);

    return {
        destroy() {
            intersectionObserver.unobserve(element);
        }
    };
};
